import { Box, Typography } from '@mui/material'
import ExtraNotes from './timesheet/details/v1/TravelingsheetPDF/ExtraNotes'

function PresentationalNotesAndComments({
	title,
	label,
	content,
	type,
	presentational = true,
	onChangeHandler,
}: {
	title: string
	label: string
	content: string
	type: 'element' | 'sub-section' | 'section'
	presentational?: boolean
	onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void
}) {
	const variant = type === 'section' ? 'h5' : type === 'sub-section' ? 'subtitle1' : 'subtitle2'
	const fSize = type === 'section' ? '1.25rem' : type === 'sub-section' ? '1rem' : '0.875rem'
	const lineHeight = type === 'section' ? '133.4%' : type === 'sub-section' ? '175%' : '157%'
	const pBlock = type === 'section' ? '0 1.5rem' : type === 'sub-section' ? '0 1.5rem' : 2

	return (
		<Box sx={{ marginTop: type === 'sub-section' ? '2rem' : 0 }}>
			<Typography
				variant={variant}
				sx={{
					paddingBlock: pBlock,
					fontFamily: 'var(--font-family)',
					fontWeight: 600,
					fontSize: fSize,
					lineHeight: lineHeight,
					color: 'var(--primary-dark)',
				}}
			>
				{title}
			</Typography>
			<ExtraNotes
				label={label}
				value={content}
				presentational={presentational}
				onChangeHandler={onChangeHandler}
			/>
		</Box>
	)
}

export default PresentationalNotesAndComments
